// import {createCourse} from '@/api/course-builderapi'

import { createCourse, createLesson, createTopic } from '../../../../api/course-builderapi'
import {repository} from '@/mixins/repository.js'

export const CourseBuilder = {
  mixins:[repository],
  data () {
    return {
      

      course_id:null,

      //couser header//
      course_header:{
        name:'',
        description:'',
        course_image:'',
        course_image_info:''

      },
      //course content
      content:{
        content:''
      },
      //course content
      course_content:'',

      //couser header//

      subject_ids:[],
      name: '',
      description:'',
      file_ids:[], //course files id
      assignment_ids:[],
      question_ids:[],
      showCourseContent:false,

      showFileContent:false,
      imported_question_details:[],
      lessons_array : [],

      //only topic component
      topics_array:[],

      //only topic component

      //for editing
      editingtrue:false,
      editingType:'',
      checkingEdit:'Save',
      subjects_added:[],
      filesInfo:[],

      platform_module_id:3,         //for all modules for by default course=3

      equipments:[],
      assets:[],
      has_all_subject:false,
    //for editing
    }
  },
  created () {
    
    this.getRepositoryId(this.platform_module_id)

  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  methods:{

    saveCourseBuilder (type) {
      //this.$validator.validateAll()
    

      
      this.$validator.validateAll('CourseBuilder').then((valid) => {
        
        
        
        if (valid) {
          if (type === 'course') {
            const course_image = []
            if (this.course_header.course_image) {
              course_image[0] = this.course_header.course_image
            } else {
              course_image.length = 0
              
            }
            let subjects = []
            this.subject_id.forEach(sub=>{
            subjects.push(sub.id)
             })
            if(!this.settings_object.class_duration && this.settings_obj.course_class_type =='online_one_2_one'){
              if(this.settings_object.session_frequency>0){
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Please provide a class duration',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 3000
                })
              } else {

                const payload = {
                  id:this.course_id,
                  subject_ids:this.has_all_subject?[]:subjects,
                  has_all_subject: this.has_all_subject,
                  name:this.course_header.name,
                  description:this.course_header.description,
                  course_image,
                  content:this.content,
                  lessons:this.lessons_array,
                  file_ids:this.file_ids,
                  assignment_ids:this.assignment_ids,
                  question_ids:this.question_ids,
                  settings_object:this.settings_object,
                  assets:this.assets
                
                }
                
                
                if (this.$route.params.courseApplicationType === 'Shared') {
                  this.removeId(payload)
    
                } else {
                  this.creatingCourse(payload)
                }
              }
            } else {

            const payload = {
              id:this.course_id,
              subject_ids:this.has_all_subject?[]:subjects,
              has_all_subject: this.has_all_subject,
              name:this.course_header.name,
              description:this.course_header.description,
              course_image,
              content:this.content,
              lessons:this.lessons_array,
              file_ids:this.file_ids,
              assignment_ids:this.assignment_ids,
              question_ids:this.question_ids,
              settings_object:this.settings_object,
              assets:this.assets
            
            }
            
            
            if (this.$route.params.courseApplicationType === 'Shared') {
              this.removeId(payload)

            } else {
              this.creatingCourse(payload)
            }
          }
          }  else if (type === 'Lessons') {
            const payload = {
              lessons:this.lessons_array
            }
            
            this.creatingLesson(payload)


          } else if (type === 'Topics') {
            if (this.topics_array.length > 0) {
              this.topics_array.forEach(element => {
                element.subject_ids = this.subject_id.map(sub=>{
                  return sub.id
                })
                element.has_all_subject = this.has_all_subject
              })
            }
            const payload = {
              topics:this.topics_array
            }
            this.creatingTopic(payload)
          }
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Fields are not validated',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            time: 3000
          })        
        }
      })
    },

    //for course moduel
    async creatingCourse (payload) {
      try {
        console.log(payload);
        if (this.checkingEdit !== 'Save') {
          this.$vs.loading({
            text:'Updating Course'
          })
        } else {
          this.$vs.loading({
            text:'Creating Course'
          })
        }
        const customer_id = this.$store.getters.customerId
        if (payload.lessons.length > 0) {
          payload.lessons.forEach(element => {
            element.subject_ids = this.subject_ids

            element.topics.forEach(eachTopis => {
              eachTopis.subject_ids = this.subject_ids

            })
            
          })
          
        }

        

        payload.custom = this.custom

        


        const resData = await createCourse(payload, customer_id)
        
        let statusMessage = 'Created'
        if (this.editingtrue) {
          statusMessage = 'Updated'
        }
        this.$vs.notify({
          title: 'Success',
          text: `Course ${statusMessage}  Successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        
        this.$router.push('/pages/course-builder/course') 

      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }
    },

    async creatingLesson (payload) {
      

      try {
        if (this.checkingEdit !== 'Save') {
          this.$vs.loading({
            text:'Updating Lesson'
          })
        } else {
          this.$vs.loading({
            text:'Creating Lesson'
          })
        }
        const customer_id = this.$store.getters.customerId
        
        if (payload.lessons.length > 0) {
          payload.lessons.forEach(element => {
            element.subject_ids = this.subject_ids
            

            if (element.topics.length > 0) {
              element.topics.forEach(element => {
                element.subject_ids = this.subject_ids
              })
            }
          })
         
        }
       
        
        const resData = await createLesson(payload, customer_id)
        
        let statusMessage = 'Created'
        if (this.editingtrue) {
          statusMessage = 'Updated'
        }
        this.$vs.notify({
          title: 'Success',
          text: `Lesson ${statusMessage}  Successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

        this.$router.push('/pages/lessonlist') 

      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }

    },
    async creatingTopic (payload) {
      try {
        if (this.checkingEdit !== 'Save') {
          this.$vs.loading({
            text:'Updating Topic'
          })
        } else {
          this.$vs.loading({
            text:'Creating Topic'
          })
        }
        
        const customer_id = this.$store.getters.customerId
        
        const resData = await createTopic(payload, customer_id)
        
        let statusMessage = 'Created'
        if (this.editingtrue) {
          statusMessage = 'Updated'
        }
        this.$vs.notify({
          title: 'Success',
          text: `Topic ${statusMessage}  Successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        
        this.$router.push('/pages/topiclist') 

      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }

    },
    removeImportedQuestions (object) {
      object.delete_import_type = 'question'
      this.openConfirm(object)
    },
    removeImportedAssignment (object) {
      object.delete_import_type = 'assignment'
      this.openConfirm(object)
    },
    openConfirm (object) {
      let deleteOneOrAll = ''
      if (object.type === 'allDelete') {
        deleteOneOrAll = 'all'
      } else {
        deleteOneOrAll = 'this'
      }
    
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: `Are you sure you want to remove ${deleteOneOrAll} ${object.delete_import_type} ?`,
        accept: this.acceptAlert,
        parameters: [object]
      })
    },
    acceptAlert (parameters) {
      
      parameters[0].object = parameters[0]
      if (parameters[0].object.delete_import_type === 'question') {
        if (parameters[0].object.type === 'allDelete') {
          setTimeout(() => {
            this.question_details = []
            this.question_ids = []
            this.imported_question_details = []
          }, 1000)
        
        } else {
          
          setTimeout(() => {
            this.question_details.splice(parameters[0].object.removeIndex, 1)
            this.question_ids.splice(parameters[0].object.removeIndex, 1)
            this.imported_question_details.splice(parameters[0].object.removeIndex, 1)
          }, 1000)
        }

      } else if (parameters[0].object.delete_import_type === 'assignment') {
        
        if (parameters[0].object.type === 'allDelete') {
          setTimeout(() => {
            this.imported_assignment_details = []
            this.assignment_ids = []
          }, 1000) 
        } else {
          this.imported_assignment_details.splice(parameters[0].object.removeIndex, 1)
          this.assignment_ids.splice(parameters[0].object.removeIndex, 1)
        }
      }
      setTimeout(() => {
        this.$vs.notify({
          color:'success',
          title:'Success',
          text: `Imported ${parameters[0].object.delete_import_type} removed`
        })
      }, 1000) 
    },
    removeId (payloadObject) {
      

      payloadObject.id = null
      if (payloadObject.content && payloadObject.content.id) {
        payloadObject.content.id = null
      }

      payloadObject.lessons.forEach(eachLesson => {
        eachLesson.id = null
        if (eachLesson.content && eachLesson.content.id) {
          eachLesson.content.id = null
        }

        eachLesson.topics.forEach(eachTopic => {
          eachTopic.id = null
          if (eachTopic.content && eachTopic.content.id) {
            eachTopic.content.id = null
          }
        })
      })

      
      this.creatingCourse(payloadObject)


    }

  }
}
